import { render, staticRenderFns } from "./FormatStrikethrough.vue?vue&type=template&id=0a065764&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FormatStrikethrough.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/FormatStrikethrough.vue
// module id = 2414
// module chunks = 1